import { useState } from "react";
import Reveal from "@/components/feature/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { faqs } from "@/mocks/faqs";

export default function FaqSection() {
  const [openId, setOpenId] = useState<string | null>(faqs[0]?.id ?? null);

  return (
    <section id="faq" className="bg-background-100 py-16 md:py-24 lg:py-28">
      <div className="u-container">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-[0.75fr_1.25fr] lg:gap-16">
          <Reveal>
            <div className="lg:sticky lg:top-32">
              <SectionHeading en="Q&amp;A" jp="よくあるご質問" />
              <a
                href="#faq"
                className="group mt-8 inline-flex items-center gap-3 whitespace-nowrap rounded-md border border-foreground-950/20 bg-background-50 px-6 py-3 text-[13px] text-foreground-900 transition-colors hover:bg-secondary-100"
              >
                すべてのQ&amp;Aを見る
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden />
              </a>
            </div>
          </Reveal>

          <Reveal delay={120}>
            <div className="border-t border-background-300/80">
              {faqs.map((faq) => {
                const isOpen = openId === faq.id;
                return (
                  <div key={faq.id} className="border-b border-background-300/80">
                    <button
                      type="button"
                      onClick={() => setOpenId(isOpen ? null : faq.id)}
                      aria-expanded={isOpen}
                      className="flex w-full items-center justify-between gap-6 py-6 text-left"
                    >
                      <span className="flex items-start gap-4">
                        <span className="font-label text-[13px] text-secondary-700">Q</span>
                        <span className="font-heading text-[15px] leading-[1.8] text-foreground-950 md:text-base">
                          {faq.q}
                        </span>
                      </span>
                      <i
                        className={`shrink-0 text-xl text-foreground-600 transition-transform duration-300 ${
                          isOpen ? "rotate-45" : ""
                        }`}
                        aria-hidden
                      >
                        <span className="ri-add-line" />
                      </i>
                    </button>
                    <div
                      className={`grid transition-all duration-300 ease-out ${
                        isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                      }`}
                    >
                      <div className="overflow-hidden">
                        <div className="flex items-start gap-4 pb-7">
                          <span className="font-label text-[13px] text-accent-700">A</span>
                          <p className="text-[13px] leading-[2.1] text-foreground-700 md:text-sm">{faq.a}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}